import type * as Types from 'app/types/graphql';

import { ClickedElementSelectFragmentDoc } from '../fragments/clickedElement.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ClickedElementsQueryVariables = Types.Exact<{
  where: Types.HeatmapClicksWhereInput;
}>;

export type ClickedElementsQueryResponse = {
  clickedElements: Array<
    Pick<
      Types.ClickedElement,
      | 'hash'
      | 'selector'
      | 'totalClicks'
      | 'totalOrders'
      | 'totalRevenue'
      | 'totalSessions'
      | 'totalSessionsThatCompletedCheckout'
      | 'totalClicksWithRevenue'
    >
  >;
};

export const ClickedElementsDocument = `
    query ClickedElements($where: HeatmapClicksWhereInput!) {
  clickedElements(where: $where) {
    ...ClickedElementSelect
  }
}
    ${ClickedElementSelectFragmentDoc}`;

export const useClickedElementsQuery = <TData = ClickedElementsQueryResponse, TError = unknown>(
  variables: ClickedElementsQueryVariables,
  options?: UseQueryOptions<ClickedElementsQueryResponse, TError, TData>,
) => {
  return useQuery<ClickedElementsQueryResponse, TError, TData>(
    ['ClickedElements', variables],
    appFetcher<ClickedElementsQueryResponse, ClickedElementsQueryVariables>(
      ClickedElementsDocument,
      variables,
    ),
    options,
  );
};

useClickedElementsQuery.getKey = (variables: ClickedElementsQueryVariables) => [
  'ClickedElements',
  variables,
];
